import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";

// AuthRoute: only for NOT logged in users (login/signup)
const AuthRoute = ({ loggedIn, isExpired, children }) => {
  // if expired, always allow login/signup
  if (isExpired) return children;

  return loggedIn ? <Navigate to="/dashboard" replace /> : children;
};

// ProtectedRoute: must be logged in
// ✅ IMPORTANT: do NOT redirect just because expired (modal handles it)
const ProtectedRoute = ({ children, loggedIn, isHydrating, isExpired }) => {
  if (isHydrating && loggedIn && !isExpired) {
    return (
      <div className="boot-splash">
        <div className="boot-orb" />
        <div className="boot-text">COSMETINK ACADEMY</div>
      </div>
    );
  }

  if (!loggedIn) return <Navigate to="/login" replace />;
  return children;
};

const mapStateToProps = (state) => ({
  loggedIn: !!state.session.isAuthenticated,
  isExpired: !!state.session.isExpired,
  isHydrating: !!state.session.isHydrating,
});


export const AuthRouteConnected = connect(mapStateToProps)(AuthRoute);
export const ProtectedRouteConnected = connect(mapStateToProps)(ProtectedRoute);
